import { Component, OnDestroy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Router, RouterModule, Event, NavigationEnd } from '@angular/router';
import { HeaderComponent } from '../layout/header/header.component';
import { FooterComponent } from '../layout/footer/footer.component';
import { filter, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

const HIDE_FOOTER_ROUTES: string[] = ['/main/cost-plan', '/main/contact-us'];

@Component({
    selector: 'main',
    standalone: true,
    imports: [ButtonModule, RouterModule, HeaderComponent, FooterComponent, CommonModule],
    templateUrl: './main.component.html',
    styleUrl: './main.component.less',
})
export class MainComponent implements OnDestroy {
    isHome: boolean = true;
    showFooter: boolean = true;
    routerEventSubscription: Subscription;

    constructor(private router: Router) {
        this.routerEventSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe({
            next: (event: Event) => {
                const currentRoute = (event as NavigationEnd).urlAfterRedirects;
                this.showFooter = HIDE_FOOTER_ROUTES.find((route: string) => currentRoute.includes(route)) ? false : true;
            },
        });
    }

    ngOnDestroy(): void {
        this.routerEventSubscription.unsubscribe();
    }
}
